import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=90fff7ec&scoped=true"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=90fff7ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fff7ec",
  null
  
)

export default component.exports